import React, { Component } from "react";
import { Link } from "react-router-dom";

import SidebarContent from "./SidebarContent";

import logoLight from "../../assets/images/logos/moore-logo-white.png";
import logoDark from "../../assets/images/logos/moore-logo-black.png";
import logoLightBlock from "../../assets/images/logos/moore-logo-white-without-name.png";
import logoDarkBlock from "../../assets/images/logos/moore-logo-black-without-name.png";

class Sidebar extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="vertical-menu">
          <div className="navbar-brand-box">
            <Link to="/dashboard" className="logo logo-dark">
              <span className="logo-sm">
                <img src={logoDarkBlock} alt="MR" height="50" />
              </span>
              <span className="logo-lg">
                <img src={logoDark} alt="MOORE BV / SRL" height="50" />
              </span>
            </Link>

            <Link to="/dashboard" className="logo logo-light">
              <span className="logo-sm">
                <img src={logoLightBlock} alt="MR" height="50" />
              </span>
              <span className="logo-lg">
                <img src={logoLight} alt="MOORE BV / SRL" height="50" />
              </span>
            </Link>
          </div>
          <div data-simplebar className="h-100">
            <SidebarContent />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Sidebar;
